import { render, staticRenderFns } from "./ReservationsTable.vue?vue&type=template&id=f5562618&"
import script from "./ReservationsTable.vue?vue&type=script&lang=js&"
export * from "./ReservationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports